// A band treats part of the ground a pass covers: 1 L/ha at a 10% band is an
// application rate of 1 L/ha and an effective, broadacre rate of 0.1 L/ha. A
// product line's rate is the application rate and the band is its record's;
// the effective rate is worked out from them (api/Services/BandRate.cs).

export const isBanded = (bandPercent?: number | null): boolean =>
  bandPercent != null && bandPercent > 0 && bandPercent < 100;

export const effectiveRate = (rate: number, bandPercent?: number | null): number =>
  (rate * (bandPercent ?? 100)) / 100;

// Effective rates get small: below 1, 3 significant digits rather than 3 decimals.
export const formatRate = (rate: number): string =>
  rate.toLocaleString('en-AU', rate !== 0 && Math.abs(rate) < 1 ? { maximumSignificantDigits: 3 } : { maximumFractionDigits: 3 });

export const bandText = (bandPercent?: number | null): string =>
  (isBanded(bandPercent) ? `${bandPercent}%` : '—');

// A band typed into a form: blank is the whole area.
export const bandInputInvalid = (text: string): boolean =>
  text.trim() !== '' && !(Number(text) > 0 && Number(text) <= 100);
